import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { routerShape } from 'react-router/lib/PropTypes';

import DateSelector from '../search/dates/DateSelector';
import trainTime from '../../lib/TrainTime';
import t from '../../lib/I18n';
import Search from '../../records/Search';
import Station from '../../records/Station';
import PointFlow from '../../flows/PointFlow';
import { PointStages, JourneyPlannerLayout } from '../../constants/AppConstants';
import Timeband from '../../records/Timeband';
import PassengersSelector from '../search/PassengersSelector';
import FamilyVerificationStore from '../../stores/FamilyVerificationStore';
import useStoreState from '../../stores/useStoreState';

const TranspennineRoverCTA = ({ router }) => {
    const getStartDate = () => {
        return trainTime();
    };

    const [selectedDate, setSelectedDate] = useState(getStartDate());
    const [adults, setAdults] = useState(1);
    const [children, setChildren] = useState(0);

    const availableTickets = useStoreState(FamilyVerificationStore, 'availableTickets');
    const isExceeded = adults + children > availableTickets;

    const handleDateChange = date => {
        setSelectedDate(date);
    };

    const handleSearch = async e => {
        e.preventDefault();

        const origin = new Station({ nlc: 'Z031' });
        const destination = new Station({ nlc: 'Z032' });
        const email = FamilyVerificationStore.getEmail();

        const searchDate = selectedDate
            .clone()
            .hour(11)
            .minute(30)
            .second(0);

        const search = new Search({
            origin,
            destination,
            adults,
            children,
            outboundDateTime: new Timeband({
                datetime: searchDate,
                arriveDepart: 'Depart',
                windowLength: 8,
            }),
            targetLayout: JourneyPlannerLayout.LIST,
            numJourneys: 8,
            email,
        });

        PointFlow.moveToNext(PointStages.SEARCH, { search }, router);
    };

    return (
        <div className="transpennine-rover-cta">
            <div className="transpennine-rover-cta__header">
                <div className="transpennine-rover-cta__header-content">
                    <h2>{t('promotion.tocFamily.rover.title')}</h2>
                </div>
            </div>

            <div className="transpennine-rover-cta__content">
                <p>{t('promotion.tocFamily.rover.description')}</p>

                <div className="transpennine-rover-cta__form">
                    <div className="transpennine-rover-cta__field">
                        <DateSelector
                            datetime={selectedDate}
                            min={getStartDate()}
                            max={trainTime().add(30, 'days')}
                            onChange={handleDateChange}
                            srOnly={t('ariaLabel.fieldDescription', {
                                field: t('promotion.tocFamily.rover.dateField'),
                            })}
                        />
                    </div>

                    <div className="transpennine-rover-cta__field transpennine-rover-cta__field--passengers">
                        <PassengersSelector
                            adults={adults}
                            children={children}
                            onAdultsChange={setAdults}
                            onChildrenChange={setChildren}
                            maxTickets={availableTickets ? availableTickets + 1 : -1}
                            hideInfo
                        />
                        {isExceeded && (
                            <div className="transpennine-rover-cta__error">
                                {t('promotion.tocFamily.rover.error', {
                                    tickets: availableTickets,
                                })}
                            </div>
                        )}
                    </div>

                    <div className="transpennine-rover-cta__field">
                        <button
                            onClick={handleSearch}
                            className="btn btn-primary"
                            type="button"
                            disabled={isExceeded}
                        >
                            {t('promotion.tocFamily.rover.buttonText')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

TranspennineRoverCTA.propTypes = {
    router: routerShape.isRequired,
};

export default withRouter(TranspennineRoverCTA);



// WEBPACK FOOTER //
// ./src/components/point/TranspennineRoverCTA.js